import { PropsWithChildren } from "react";
import { useRouter } from "next/router";
import Link from "next/link";

import { useMeQuery, useUserInfoQuery } from "@chef/state-management";
import { BRAND_PATHS, FEATURE_FLAGS } from "@chef/constants";
import { useFlag } from "@chef/feature-flags";

import { AppShell } from "./AppShell";
import { Logo } from "./Logo";

import { intl } from "./MaintenanceMode.Intl";

export const MaintenanceMode = ({ children }: PropsWithChildren) => {
  const router = useRouter();

  const { data: isLoggedIn } = useMeQuery();
  const { data: userInfoQuery } = useUserInfoQuery(undefined, {
    skip: !isLoggedIn,
  });

  const { enabled: isEnabled } = useFlag(FEATURE_FLAGS.MAINTENANCE);

  const isApp =
    router.pathname.startsWith("/app") ||
    router.pathname.startsWith("/mina-sidor");

  if (isEnabled && isApp) {
    return (
      <AppShell.Main className="pt-10 page-padding">
        <div className="flex flex-col h-full max-w-screen-sm gap-6 mx-auto md:max-w-screen-md">
          <h1>
            <strong>
              {intl.HI} {userInfoQuery?.userInfo.firstName}!
            </strong>
          </h1>
          <p className="text-lg">{intl.RIGHT_NOW_WE_ARE_WORKING}</p>
          <p className="text-lg">{intl.WE_APOLOGIZE_FOR_THE_INCONVENIENCE}</p>
          <p className="text-lg">
            {intl.IF_YOU_HAVE_QUESTIONS}{" "}
            <Link href={BRAND_PATHS.CONTACT_US_PAGE_LOGOUT}>
              <strong className="underline">
                {intl.CUSTOMER_SERVICE_HERE}
              </strong>
            </Link>
            .
          </p>
          <div aria-hidden="true" className="grow" />
          <div className="py-6">
            <Logo />
          </div>
        </div>
      </AppShell.Main>
    );
  }

  return children;
};
